import { InstrumentType, InstrumentDefinition, TuningDefinition } from '../types';

export const MANDOLIN_STANDARD_TUNING: TuningDefinition = {
  id: 'mandolin-standard',
  label: 'Standard (Mandolin)',
  pitches: [
    { note: 'E', octave: 5 },
    { note: 'A', octave: 4 },
    { note: 'D', octave: 4 },
    { note: 'G', octave: 3 },
  ],
};

export const MANDOLIN_DEFINITION: InstrumentDefinition = {
  type: InstrumentType.Mandolin,
  name: 'Mandolin',
  defaultNumFrets: 20,
  defaultTunings: [MANDOLIN_STANDARD_TUNING],
};
